import { useEffect, useState } from "react";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";


const useBillOfMaterialPlanGetDetail = (bomID) => {
  const [billOfMaterialDet, setBillOfMaterialDet] = useState(null);
  const [planmaterialList, setPlanMaterialList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const companyID = localStorage.getItem("companyid");
        const plantID = 1;

        // Parameters for the API calls
        const bomParams = { p_companyid: companyID, p_plantid: plantID, p_id_bom: bomID };
        const productParams = { p_companyid: companyID, p_plantid: plantID };

        // Fetch data concurrently
        const [billOfMaterialResponse, billOfMaterialData] = await Promise.all([
          callApi(API_ENDPOINTS.BILL_MATERIAL_GET_DETAIL, "POST", { "Content-Type": "application/json" }, bomParams),
          callApi(API_ENDPOINTS.MATERIAL_GET_LIST, "POST", { "Content-Type": "application/json" }, productParams),
        ]);

        // Update state with API data
        setBillOfMaterialDet(billOfMaterialResponse[0] || null);
        setPlanMaterialList(billOfMaterialData || []);
      } catch (err) {
        console.error("Failed to fetch bill of material data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [bomID]);

  return { billOfMaterialDet,  planmaterialList, loading, error };
};

export default useBillOfMaterialPlanGetDetail;
